import React from 'react';

interface MultiSelectButtonProps {
  label: string;
  value: any;
  selected: boolean;
  onClick: (value: any) => void;
  disabled?: boolean;
}

const MultiSelectButton: React.FC<MultiSelectButtonProps> = ({ label, value, selected, onClick, disabled }) => {
  return (
    <button
      type="button"
      onClick={() => !disabled && onClick(value)}
      style={{
        background: selected ? 'rgba(250,253,251,0.12)' : 'rgba(250,253,251,0.08)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: `2px solid ${selected ? 'var(--color-primary)' : 'rgba(250,253,251,0.08)'}`,
        borderRadius: 16,
        padding: '16px 12px',
        color: 'var(--color-text-light)',
        fontFamily: "'Figtree', sans-serif",
        fontSize: 16,
        fontWeight: 400,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled && !selected ? 0.4 : 1,
        transition: 'all 0.2s ease',
        textAlign: 'center',
        minWidth: 0,
      }}
    >
      {label}
    </button>
  );
};

export default MultiSelectButton;
